const state = {
  leftColumn: {
    isExpanded: true,
    profile: {
      isExpanded: false
    },
    starredMessage: {
      isExpanded: false
    },
    newConversation: {
      isExpanded: false,
      stateTransition: 'slideLeft',
      viewState: 'contactList'
    }
  },

  rightSideColumn: {
    isExpanded: false,
    visibleContent: ''
  },

  emojiKeyboard: {
    isShown: false
  },
  audioInputActive: false,
  messages: {
    balloonsTransitionName: 'flip-list',
    userColors: []
  },
  modal: {
    viewState: 'addToGroup'
  },
  messageInfoModal: {
    isOpen: false,
    message: null
  }
}

const getters = {}

const mutations = {
  setMessageBalloonsTransitionName (state, data) {
    state.messages.balloonsTransitionName = data
  },

  setNewConversationViewState (state, data) {
    state.leftColumn.newConversation.viewState = data
  },

  setNewConversationStateTransition (state, data) {
    state.leftColumn.newConversation.stateTransition = data
  }
}

const actions = {}
export default {
  state,
  getters,
  mutations,
  actions
}
